import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

import { Subscription, tap } from 'rxjs';
import { RentalObjectDocumentService } from '../../service/data/rental-object-document.service';
import { RentalObject } from '../../model/rental-object';
import { RentalObjectDocument } from '../../model/rental-object-document';
import { RentalObjectDocumentType, RentalObjectDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';

@Component({
    selector: 'app-rental-object-document-form',
    templateUrl: './rental-object-document-form.component.html',
    styleUrls: ['./rental-object-document-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectDocumentFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: RentalObjectDocumentService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _renderer: Renderer2
  ) {}

  @ViewChild('uploadFile') uploadFileElement: ElementRef;

  private _subscription: Subscription = new Subscription();
  dataContext: RentalObject;
  form: FormGroup;

  connectionTypes: SelectionItem[];

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.connectionTypes = [
      RentalObjectDocumentType.General,
      RentalObjectDocumentType.InteriorPhoto,
      RentalObjectDocumentType.FloorPlan,
    ].map(t => new SelectionItem(RentalObjectDocumentTypeToString(t), t));

    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      connectionType: this._fcf.createMandatory('DOCUMENT.DOCUMENT_TYPE', RentalObjectDocumentType.General),
      document: this._fcf.createMandatory('', null),
      rentalObject: this._fcf.createHidden(this.dataContext.id),
    });
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      this.form.controls['document'].setValue(files[0]);
      this.form.controls['caption'].setValue(files[0].name.substr(0, files[0].name.lastIndexOf('.')));
    } else {
      this.form.controls['caption'].reset();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService
          .add(Object.assign(new RentalObjectDocument(), this.form.value))
          .subscribe(() => this._actionService.complete(true)) // Complete with true to trigger reload
      );
    }
  }
}
